export const DISABLE_THIRD_PARTY = 'DISABLE_THIRD_PARTY'
export const ENABLE_THIRD_PARTY = 'ENABLE_THIRD_PARTY'
export const DEBUG_THIRD_PARTY = 'DEBUG_THIRD_PARTY'
export const COX_ONLY = 'COX_ONLY'
export const RESET_CUSTOM = 'RESET_CUSTOM'
export const INVALID_PROTOCOL = 'INVALID_PROTOCOL'
export const DEVICE_ENABLEMENT = 'DEVICE_ENABLEMENT'

export const LOADING_INTEGRATION_JS = 'LOADING_INTEGRATION_JS'